import { render, staticRenderFns } from "./PayrollReportsTable.vue?vue&type=template&id=4a2fa887&"
import script from "./PayrollReportsTable.vue?vue&type=script&lang=ts&"
export * from "./PayrollReportsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollReportsTable.vue?vue&type=style&index=0&id=4a2fa887&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports